import { render, staticRenderFns } from "./storing.vue?vue&type=template&id=6aa89da6&scoped=true&"
import script from "./storing.vue?vue&type=script&lang=js&"
export * from "./storing.vue?vue&type=script&lang=js&"
import style0 from "./storing.vue?vue&type=style&index=0&id=6aa89da6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa89da6",
  null
  
)

export default component.exports